import { InjectionToken } from '@angular/core';
import { BootFuncParams } from 'aspnet-prerendering';

export const API_URL = new InjectionToken<string>('API_URL');
export const IS_SERVER_SIDE = new InjectionToken<boolean>('IS_SERVER_SIDE');
export const SSR_PAGE_DATA = new InjectionToken<string | null>('SSR_PAGE_DATA');
export const BASE_URL = new InjectionToken<string>('BASE_URL');
export const BOOT_PARAMS = new InjectionToken<BootFuncParams>('BOOT_PARAMS');
